define([
	"dojo/_base/declare",
	"csi/util"
], function(declare, util) {

	return declare(null, {
		// Boolean: indicates if preference paths of target class should be added as well (normally only used on Relationship/PreferencePath) 
		bAddTargetPaths: false,

		constructor: function(def) {
			this.m_path = util.getProperty(def, 'Path');
			this.bAddTargetPaths = (util.getProperty(def, "AddTargetPaths") == "1");
		}
	});
});